<aside
  class="sidebar flex h-screen flex-col border-r border-gray-200 bg-white px-2 transition-all duration-300 dark:border-gray-800 dark:bg-black overflow-visible"
  [class.w-[75px]]="layoutService.isMenuCollapsed()"
>
  <!-- SIDEBAR HEADER -->
  @if(!layoutService.isMenuCollapsed()) {
    <div class="pt-4 w-full flex sidebar-header pb-3 mb-2 justify-between">
      <a
        class="flex justify-start"
        [routerLink]="['/dashboard']"
        [class.ml-2]="!(layoutService.isMenuCollapsed())"
      >
        <span class="logo">
          <app-logo></app-logo>
        </span>
      </a>
    </div>

    <!-- SIDEBAR CONTENT -->
    <div class="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear pb-20">
      <app-menu></app-menu>
    </div>
  } @else {
    <!-- Menu compact ! -->
    <div class="pt-8 pb-3 sidebar-header-compact flex justify-center">
      <app-logo [logoOnly]="true"></app-logo>
    </div>

    <!-- Menu collapsed avec icônes seulement -->
<!--    <div class="flex flex-col space-y-2 align-items-center overflow-visible">-->
    <div class="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear pb-20">
      <app-menu [collapsed]="true"></app-menu>
    </div>
  }


  <!-- BUG REPORT BUTTON -->
  @if (ROLES.admin.indexOf(user?.profil?.name) > -1 && environment?.Modules?.DEVnet) {
    <btnBugReport
        class="absolute bottom-4 left-4"
    ></btnBugReport>
  }
</aside>
